/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャット開始前のユーザ選択パネル
 *
 * @author jimu
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-chat-user-certificate-select-pane">

  <el-main class="main-area">
    <p class="information-text">{{$t('ご利用いただきありがとうございます。')}}<br>{{$t('以下ボタンを選択してください。')}}</p>
    <div class="user-certificate-button-body">
      <el-button type="primary" class="user-certificate-button" @click="doUserCertificate">{{$t('サービスをご利用中のお客様')}}</el-button>
    </div>
  </el-main>

</el-container>
</template>

<script>
import {
  Container,
  Main,
  Button
} from 'element-ui'

export default {
  name: 'FcChatJoinPane',
  components: {
    'el-container': Container,
    'el-main': Main,
    'el-button': Button
  },
  methods: {
    /**
     *  サービスをご利用中のお客様を選択
     * @param  {Function} callback
     */
    doUserCertificate() {
      this.$emit('openUserCertificate')
    },
    /**
     *  お申し込み前のお客様を選択
     */
    doUserNoCertificate() {
      this.$emit('openUserNoCertificate')
    }
  }
}
</script>

<style scoped>
.fc-chat-user-certificate-select-pane {
  height: auto;
}

.main-area {
  background-color: rgb(142, 211, 251);
  flex: 2;
}

.user-certificate-button {
  width: 100%;
}

.user-certificate-button-body {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/chatUserCertificateSelect/FcChatUserCertificateSelectPane.vue